import { createSlice } from "@reduxjs/toolkit";

const initialState = {
}

const DataStore = createSlice({
  name: 'DataStore',
  initialState,
  reducers: {
    AddData(state, action) {
      state[action.payload.name] = action.payload.data
    },
  },
  extraReducers: builder => {

  },
})
export const DataStoreReducer = DataStore.reducer;

export const { AddData } = DataStore.actions